import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import RouterUtils from '../../routing/RouterUtils';
import { PsRoutes } from '../../routing/Routes';
import Link from 'react-router-dom/Link';
import { ActiveBadge } from '../../components/ActiveLabel';
import { PsListTable } from '../../components/list-table/PsListTable';
import { PsCompanyManagement } from '../../model/PsCompanyManagement';

export class WorkListTable extends React.Component {

    render() {
        const {
            data,
            error,
            companyManagement,
            enableEmailAlerts,
        } = this.props;

        const route = companyManagement === PsCompanyManagement.MY_CONTRACTORS
            ? PsRoutes.MY_CONTRACTORS_WORKS_DETAIL
            : PsRoutes.MY_OUTSOURCES_WORKS_DETAIL;

        const showEmailAlert = enableEmailAlerts && (companyManagement !== PsCompanyManagement.MY_CONTRACTORS);

        return (
            <PsListTable
                data={data}
                error={error}
                headings={(
                    <tr>
                        <th>{I18nUtils.tr('TR_ESTADO')}</th>
                        <th>{I18nUtils.tr('TR_CODIGO')}</th>
                        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                        <th>{I18nUtils.tr('TR_FECHA_INICIO')}</th>
                        <th>{I18nUtils.tr('TR_FECHA_FIN')}</th>
                        {showEmailAlert && <th>{I18nUtils.tr('TR_EMAIL_PARA_AVISOS')}</th>}
                    </tr>
                )}
            >
                {
                    data.map((work) => {
                        const id = work.id();
                        const to = RouterUtils.generateRoute(route, { id });

                        return (
                            <tr key={id}>
                                <td><ActiveBadge active={work.isActive()}/></td>
                                <td>{work.code()}</td>
                                <td><Link to={to}>{work.name()}</Link></td>
                                <td>{work.startDateString()}</td>
                                <td>{work.endDateString()}</td>
                                {showEmailAlert && <td>{work.noticesEmail()}</td>}
                                <td></td>
                            </tr>
                        );
                    })
                }
            </PsListTable>
        );
    }

}

WorkListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    companyManagement: PropTypes.string.isRequired,
    enableEmailAlerts: PropTypes.bool,
};
WorkListTable.defaultProps = {
    data: [],
    error: '',
};



// WEBPACK FOOTER //
// ./src/app/shared/work/list/WorkListTable.jsx